export default {
    title: 'Market Opportunities'
}
